import { Map } from '../language/models';
import { TextDirection } from './textDirection';
import { Language } from './models';
import { defaultLanguages } from './defaultLanguages';


/**
 * Gets the cross section between the user's supported languages and the languages we have translations for.
 * @param supportedLanguages - The list of languages we have translations for
 * @param languages - The list of languages the user's computer says the user speaks
 * @param defaultLang - The language to use if no translation/user language intersection is found
 */
export const getSupportedLanguage = (
  supportedLanguages: Map<Language>,
  languages: readonly string[],
  defaultLang: Language = defaultLanguages['en'],
): Language => {
  const intersection = (languages || []).find(
    userLang => !!supportedLanguages[userLang],
  );

  return supportedLanguages[intersection || ''] ?? defaultLang;
};


/**
 * Predicate for whether or not the given TextDirection is TextDirection.RTL
 */
export const isRtl = (textDirection: TextDirection): boolean => textDirection === TextDirection.RTL;


/**
 * Function accepting a Message from the server and performing the specified replacements on that text. If no
 * replacements are specified, then the string is just returned.
 */
export const doMsgReplacements = (
  text: string,
  replace: Map<string | number | undefined> | undefined,
): string => {
  if (!replace) {
    return text;
  }

  return Object
    .keys(replace)
    .reduce<string>(
      (running, next) => running.replace(new RegExp('{' + next + '}', 'g'), `${replace[next] ?? ''}`),
      `${text}`,
    );
};
